<template>
  <div class="container">
    <dingbu @cart-tatus="cartTatus"></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">精选课程</span>
            </div>
          </div>
        </div>
        <div class="box-content">
          <div class="box-lo">
            <router-link
              tag="div"
              class="box-tos"
              v-for="(item, index) in addki"
              :key="index"
              :to="{ path: '/details', query: { id: item.id } }"
            >
              <div class="tos-img">
                <img class="shiping-img" :src="item.image" alt />
                <img class="bofang" src="../../assets/bofang_icon@2x.png" alt />
                <div class="shichang">{{ item.duration }}</div>
              </div>
              <div class="tos-title">{{ item.title }}</div>
              <div class="tos-time">{{ item.createtime }}</div>
            </router-link>
          </div>

          <div class="fenye">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              :total="total"
              :page-size="pageNum"
              @prev-click="prev"
              @next-click="next"
              @current-change="current"
            ></el-pagination>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      addki: [],
      page: 1,
      pageNum: 9,
      total: 1,
      bei_ing: this.Public.bei_ing,
    };
  },
  mounted() {
    this.getvideo_list()
  },
  methods: {
    cartTatus(val) {
      this.addki = val.info
      this.total = val.total_num
    },
    //分页
    //上一页
    prev() {
      console.log("eee")
      this.page = this.page - 1
      this.getvideo_list()
    },
    //下一页
    next() {
      console.log("eee")
      this.page = this.page + 1
      this.getvideo_list()
    },
    //当前页
    current(e) {
      console.log(e)
      this.page = e
      this.getvideo_list()
    },
    //优选课程列表接口
    getvideo_list() {
      let that = this;
      var url = "lists/video_list";
      let param = {
        page: this.page,
        pageNum: this.pageNum
      };
      this.post(url, param)
        .then((res) => {
          this.addki = res.data.info
          this.total = res.data.total_num
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2d52b1 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped>
@import "../../css/curriculum.css";
</style>